import React from "react";
import { useTranslation } from "react-i18next";
import { ImageLoginCircle } from "../../assets/ImageLoginCircle";
import { IconNavigationCheck } from "../../assets/IconNavigationCheck";
import { ImageBrandGol } from "../../assets/ImageBrandGol";
import { ImageBrandSmiles } from "../../assets/ImageBrandSmiles";
import { ImageBrandSmilesViagens } from "../../assets/ImageBrandSmilesViagens";

export function RightSidebar() {
  const { t } = useTranslation('acesso'); 
  
    return (
      <div className="right-sidebar-container">
        <div className="right-box-wrapper">
          <ImageLoginCircle />

          <h2>
            {t('smiles_01_a_04.title2.start')}
            {' '}
            <span className="text-highlight">{t('smiles_01_a_04.title2.highlight')}</span>
            {' '}
            {t('smiles_01_a_04.title2.end')}
          </h2>

          <div className="navigation-list">
            <div className="navigation-item">
              <IconNavigationCheck />
              <p>
                {t('smiles_01_a_04.text3')}
              </p>
            </div>
            <div className="navigation-item">
              <IconNavigationCheck />
              <p>
                {t('smiles_01_a_04.text4')}
              </p>
            </div>
            <div className="navigation-item">
              <IconNavigationCheck />
              <p>
                {t('smiles_01_a_04.text5')}
              </p>
            </div>
          </div>

          <div className="brand-icons">
            <ImageBrandGol />
            <ImageBrandSmiles />
            <ImageBrandSmilesViagens />
          </div>
        </div>
      </div>
    )
}